/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2f05b5d114cedeed55a336a777e54b9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { JiraServiceManagementDataCenterLogoCS } from './logo-cs';
export { JiraServiceManagementDataCenterIcon } from './icon';
